import { MenuItem } from "./../../../../layout/menu-item";
import { LayoutStoreService } from "./../../../../layout/layout-store.service";
import {
  ChangeDetectorRef,
  Component,
  Injector,
  Input,
  OnInit,
} from "@angular/core";
import { AppComponentBase } from "../../../../app-component-base";
import {
  Router,
  RouterEvent,
  NavigationEnd,
  PRIMARY_OUTLET,
} from "@angular/router";
import { BehaviorSubject, Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { CandidatoDto } from "@shared/service-proxies/service-proxies";
import { CandidatoService } from "candidato/service/candidato.service";

@Component({
  selector: "sidebar-menu",
  templateUrl: "./sidebar-menu.component.html",
  styleUrls: ["./sidebar-menu.component.scss"],
})
export class MainSidebarMenuComponent
  extends AppComponentBase
  implements OnInit {
  menuItems: MenuItem[];
  menuItemsMap: { [key: number]: MenuItem } = {};
  activatedMenuItems: MenuItem[] = [];
  routerEvents: BehaviorSubject<RouterEvent> = new BehaviorSubject(undefined);
  homeRoute = "/app/home";
  sidebarExpanded: boolean;
  @Input() route: String;
  candidatoDto: CandidatoDto;
  private candidatoSub: Subscription = new Subscription();

  constructor(
    injector: Injector,
    private router: Router,
    private _layoutStore: LayoutStoreService,
    public candidatoService: CandidatoService,
    private cdr: ChangeDetectorRef
  ) {
    super(injector);
    this.router.events.subscribe(this.routerEvents);
  }

  ngOnInit(): void {
    switch (this.route) {
      case "empresa":
        this.menuItems = this.getMenuItemsEmpresa();
        break;
      case "candidato":
        this.menuItems = this.getMenuItemsCandidato();
        break;
      case "administrativo":
        this.menuItems = this.getMenuItemsAdministrativo();
        break;
      case "empresa-especial":
        this.menuItems = this.getMenuItemsEmpresaEspecial();
        break;
      default:
        this.menuItems = [];
        break;
    }

    this.patchMenuItems(this.menuItems);

    if (this.route === "candidato") {
      this.initCandidato();
    }

    this.routerEvents
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        const currentUrl = event.url !== "/" ? event.url : this.homeRoute;
        const primaryUrlSegmentGroup =
          this.router.parseUrl(currentUrl).root.children[PRIMARY_OUTLET];
        if (primaryUrlSegmentGroup) {
          this.activateMenuItems("/" + primaryUrlSegmentGroup.toString());
        }
      });

    this._layoutStore.sidebarExpanded.subscribe((value) => {
      this.sidebarExpanded = value;
    });

    this.routerEvents
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => { });
  }

  getMenuItemsEmpresa(): MenuItem[] {
    const items = [
      new MenuItem(
        this.l("HomePage"),
        "/empresa/home",
        "fa-solid fa-bag-shopping"
      ),
      new MenuItem(
        this.l("Perfil"),
        "/empresa/perfil",
        "fa-regular fa-circle-user",
        "Pages.Empresas"
      ),
    ];

    return items;
  }

  getMenuItemsCandidato(): MenuItem[] {
    const items = [
      new MenuItem(
        this.l("HomePage"),
        "/candidato/home",
        "fa-solid fa-bag-shopping"
      ),
      new MenuItem(
        this.l("Inscricoes"),
        "/candidato/inscricoes",
        "fas fa-file-signature"
      ),
      new MenuItem(
        this.l("Currículo"),
        "/candidato/meu-curriculo",
        "fas fa-user-tie"
      ),
    ];

    return items;
  }

  getMenuItemsAdministrativo(): MenuItem[] {
    const items = [
      new MenuItem(
        this.l("HomePage"),
        "/administrativo/home",
        "fa-solid fa-bag-shopping"
      ),
      new MenuItem(
        this.l("Tenants"),
        "/administrativo/tenants",
        "fa-regular fa-building",
        "Pages.Tenants"
      ),
      new MenuItem(
        this.l("Users"),
        "/administrativo/users",
        "fas fa-users",
        "Pages.Users"
      ),
      new MenuItem(
        this.l("Indicadores"),
        "/administrativo/dashboards",
        "fas fa-chart-line",
        "Pages.Dashboards"
      ),
      new MenuItem(
        this.l("Empresas"),
        "/administrativo/empresas",
        "fa-regular fa-building",
        "Pages.EmpresasGestao"
      ),
      new MenuItem(
        this.l("Candidatos"),
        "/administrativo/candidatos",
        "fas fa-user-tie",
        "Pages.CandidatosGestao"
      ),
      new MenuItem(
        this.l("Contratados"),
        "/administrativo/contratados",
        "far fa-handshake",
        "Pages.Contratados"
      ),
      new MenuItem(
        this.l("Vagas"),
        "/administrativo/vagas",
        "fas fa-network-wired",
        "Pages.Vagas"
      ),
      new MenuItem(
        this.l("Comunidades"),
        "/administrativo/comunidades",
        "fas fa-vihara",
        "Pages.ComunidadesGestao"
      ),
      new MenuItem(
        this.l("LogoEmpresa"),
        "/administrativo/logo-empresa",
        "far fa-image",
        "Pages.LogoEmpresas"
      ),
      new MenuItem(
        this.l("Roles"),
        "/administrativo/roles",
        "fas fa-theater-masks",
        "Pages.Roles"
      ),
      new MenuItem(
        this.l("TermosUso"),
        "/administrativo/termos",
        "far fa-file-alt",
        "Pages.Termos_Uso"
      ),
      new MenuItem(
        this.l("PoliticaPrivacidade"),
        "/administrativo/politicas",
        "fas fa-vote-yea",
        "Pages.Politica_Privacidade"
      ),
      new MenuItem(
        this.l("Tipos de Profissonais"),
        "/administrativo/profissionais",
        "fas fa-user-tie",
        "Pages.Tipos_Profissional"
      ),
      new MenuItem(
        this.l("Questionarios"),
        "/administrativo/questionarios",
        "fas fa-question",
        "Pages.Questionarios"
      ),
    ];

    return items;
  }

  getMenuItemsEmpresaEspecial(): MenuItem[] {
    const items = [
      new MenuItem(
        this.l("HomePage"),
        "/empresa-especial/home",
        "fa-solid fa-bag-shopping"
      ),
      new MenuItem(
        this.l("Perfil"),
        "/empresa-especial/perfil",
        "fas fa fa-user",
        "Pages.EmpresasEspecial"
      ),
    ];

    return items;
  }

  initCandidato(): void {
    this.candidatoDto = this.candidatoService.getCandidato();
    this.candidatoSub = this.candidatoService
      .getCandidatoUpdateListener()
      .subscribe((candidat: CandidatoDto) => {
        this.candidatoDto = candidat;
        this.cdr.markForCheck();
      });
  }

  patchMenuItems(items: MenuItem[], parentId?: number): void {
    items.forEach((item: MenuItem, index: number) => {
      item.id = parentId ? Number(parentId + "" + (index + 1)) : index + 1;
      if (parentId) {
        item.parentId = parentId;
      }
      if (parentId || item.children) {
        this.menuItemsMap[item.id] = item;
      }
      if (item.children) {
        this.patchMenuItems(item.children, item.id);
      }
    });
  }

  activateMenuItems(url: string): void {
    this.deactivateMenuItems(this.menuItems);
    this.activatedMenuItems = [];
    const foundedItems = this.findMenuItemsByUrl(url, this.menuItems);
    foundedItems.forEach((item) => {
      this.activateMenuItem(item);
    });
  }

  deactivateMenuItems(items: MenuItem[]): void {
    items.forEach((item: MenuItem) => {
      item.isActive = false;
      item.isCollapsed = true;
      if (item.children) {
        this.deactivateMenuItems(item.children);
      }
    });
  }

  findMenuItemsByUrl(
    url: string,
    items: MenuItem[],
    foundedItems: MenuItem[] = []
  ): MenuItem[] {
    items.forEach((item: MenuItem) => {
      if (item.route === url) {
        foundedItems.push(item);
      } else if (item.children) {
        this.findMenuItemsByUrl(url, item.children, foundedItems);
      }
    });
    return foundedItems;
  }

  activateMenuItem(item: MenuItem): void {
    item.isActive = true;
    if (item.children) {
      item.isCollapsed = false;
    }
    this.activatedMenuItems.push(item);
    if (item.parentId) {
      this.activateMenuItem(this.menuItemsMap[item.parentId]);
    }
  }

  exibirAvisoDados() {
    if (this.candidatoDto &&
      (this.candidatoDto.curriculoDadoPessoal == undefined) ||
      (this.candidatoDto.curriculoDadoPessoal != undefined && !this.candidatoDto.curriculoDadoPessoal.corRacaString) ||
      ((this.candidatoDto.curriculoDadoPessoalAnexo == undefined || this.candidatoDto.curriculoDadoPessoalAnexo.arquivoNome == "") &&
        (
          this.candidatoDto.curriculosExperiencias?.length == 0 &&
          this.candidatoDto.candidatosFormacoesAcademicas?.length == 0 &&
          this.candidatoDto.candidatosIdiomas?.length == 0 &&
          this.candidatoDto.curriculosCompetencias?.length == 0
        )
      )) {
      return true
    }
    return false;
  }

  isMenuItemVisible(item: MenuItem): boolean {
    if (!item.permissionName) {
      return true;
    }
    return this.permission.isGranted(item.permissionName);
  }
}
